import client from 'client';
import { useMutation, useQueryClient } from 'react-query';
import { MeetingsHttpKey } from '../ManageMeetings/useMeetingsData';

const cancelMeeting = ({ eventId, meetingId }: { eventId: number; meetingId: string }) => {
    return client().post<void>(
        `/api/v2/meetings/events/${eventId}/scheduledMeetings/${meetingId}/cancel`
    );
};

const useCancelMeeting = () => {
    const queryClient = useQueryClient();
    return useMutation(cancelMeeting, {
        onMutate: () => {
            queryClient.cancelQueries(MeetingsHttpKey.Meetings);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsGroups);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(MeetingsHttpKey.Meetings);
            queryClient.invalidateQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.invalidateQueries(MeetingsHttpKey.MeetingsGroups);
        },
        useErrorBoundary: true,
    });
};

export default useCancelMeeting;
